module.exports = __webpack_public_path__ + "media/images/icon__unlocked@3x-81787e9b4db561cfd097ec08dfa4e1cf.png";